import { render, staticRenderFns } from "./CloseModal.vue?vue&type=template&id=c23e9692&scoped=true&"
import script from "./CloseModal.vue?vue&type=script&lang=js&"
export * from "./CloseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23e9692",
  null
  
)

export default component.exports